import React from "react";
export default function SmallBusinessGallery({data}) {

  return (
    <>
      {data && data?.map((item, index) => (
        <section key={index} className="business-gallery-area">
          <div className="container">
            <div className="row align-items-center justify-content-between">
             
              <div className={`col-lg-6 col-md-6 ${index % 2 === 0 ? null : 'order-md-1'}`}>
                <div className={`business-gallery-img ${index % 2 === 0 ? null : "business-gallery-imgleft"}`}>
                  <img src={item?.img} alt="business-gallery-image" />
                  <span>{item?.label}</span>
                </div>
              </div>

              <div className={`col-lg-5 col-md-6 ${index % 2 === 0 ? null : 'order-md-0'}`}>
                <h3 className="heading">{item?.head}</h3>
                <ul>
                  {item?.list?.map((li, i) => (
                    <li key={i}>{li}</li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
        </section>
      ))}
    </>
  )
}